var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table sort" }, [
    _c("tfoot", [
      _vm.newFields.length
        ? _c("tr", [
            _c(
              "td",
              {
                staticClass: "col-xs-4 oc-settings__add-row",
                attrs: { colspan: "2" }
              },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.field,
                        expression: "field"
                      }
                    ],
                    staticClass: "oc-settings-select",
                    staticStyle: { width: "100%" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.field = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: {} } }, [
                      _vm._v("Выберите поле")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.newFields, function(field, index) {
                      return !_vm.existField(field)
                        ? _c(
                            "option",
                            { key: index, domProps: { value: field } },
                            [_vm._v(_vm._s(field.title))]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass:
                  "oc-settings__field-value-col oc-settings__add-row",
                attrs: { colspan: "3" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "oc-settings-btn",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.addItem.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Добавить поле")]
                )
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      {
        directives: [
          {
            name: "sortable",
            rawName: "v-sortable",
            value: _vm.getSortParams(),
            expression: "getSortParams()"
          }
        ]
      },
      _vm._l(_vm.settings.form_fields, function(item, index) {
        return _c("tr", { key: index }, [
          _vm._m(0, true),
          _vm._v(" "),
          _c("td", { staticClass: "oc-settings__field-name-col" }, [
            _vm._v(
              "\n\t                " + _vm._s(item.title) + "\n                "
            )
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "oc-settings__field-value-col" }, [
            item.type == "text_html" || item.type == "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.form_fields[index].text,
                      expression: "settings.form_fields[index].text"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "" },
                  domProps: { value: _vm.settings.form_fields[index].text },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.settings.form_fields[index],
                        "text",
                        $event.target.value
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            item.type == "tel"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.form_fields[index].mask,
                      expression: "settings.form_fields[index].mask"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "+7(###)###-##-##" },
                  domProps: { value: _vm.settings.form_fields[index].mask },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.settings.form_fields[index],
                        "mask",
                        $event.target.value
                      )
                    }
                  }
                })
              : item.type == "topic"
                ? _c(
                    "a",
                    {
                      staticClass: "oc-inline-link oc-form__topic_add",
                      attrs: { href: "#/ordercall" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("openTopic")
                        }
                      }
                    },
                    [_vm._v("Добавить тему")]
                  )
                : item.type == "time"
                  ? _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settings.form_fields[index].before,
                            expression: "settings.form_fields[index].before"
                          }
                        ],
                        staticClass: "oc-settings-time-input",
                        attrs: { type: "time" },
                        domProps: {
                          value: _vm.settings.form_fields[index].before
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.settings.form_fields[index],
                              "before",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settings.form_fields[index].after,
                            expression: "settings.form_fields[index].after"
                          }
                        ],
                        staticClass: "oc-settings-time-input",
                        attrs: { type: "time" },
                        domProps: {
                          value: _vm.settings.form_fields[index].after
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.settings.form_fields[index],
                              "after",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e()
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "oc-settings__field-value-col" }, [
            _vm.isLabelVisible(item.type)
              ? _c(
                  "label",
                  { staticClass: "oc-settings__field-label" },
                  [
                    _c("checkbox", {
                      staticClass: "valign-bottom",
                      attrs: {
                        checked: !!_vm.settings.form_fields[index].required
                      },
                      on: {
                        change: function(val) {
                          _vm.settings.form_fields[index].required = +val
                        }
                      }
                    }),
                    _vm._v(
                      "\n                    Обязательное\n                  "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isCheckboxSelected(item.type)
              ? _c(
                  "label",
                  { staticClass: "oc-settings__field-label" },
                  [
                    _c("checkbox", {
                      staticClass: "valign-bottom",
                      attrs: {
                        checked: !!+_vm.settings.form_fields[index].is_checked
                      },
                      on: {
                        change: function(val) {
                          _vm.settings.form_fields[index].is_checked = val
                        }
                      }
                    }),
                    _vm._v(
                      "\n                    Сразу выбрано\n                  "
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "oc-col_min-width" }, [
            _c(
              "span",
              {
                staticClass: "oc-clickable",
                on: {
                  click: function($event) {
                    return _vm.deleteItem(index)
                  }
                }
              },
              [_c("i", { staticClass: "oc-icon16 ico-delete" })]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "oc-col_min-width" }, [
      _c("i", {
        staticClass: "icon16 sort sort-handle",
        staticStyle: { cursor: "move" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87e63bf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87e63bf0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/FormCreator.vue
// module id = 114
// module chunks = 0